import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import TextInputMaskFormik from "../../../../components/UI/TextInput/TextInputMaskFormik";
import useBuscaComposicao from "../hooks/useBuscaComposicao";

const DemonstrativoR = ({ formik, sqAcaoFiscal, sqItemOcorrencia, dadosOcorrencia }) => {
  const { calculaIcmsR, handleMoneyChange, calculaData, calculaBaseCalculoR } = useAcoesDemonstrativo({
    formik,
    sqAcaoFiscal,
  });

  const { buscaComposicao, composicao } = useBuscaComposicao({ sqAcaoFiscal, sqItemOcorrencia });
  const [disabled, setDisabled] = useState(false);

  const { setFieldValue } = formik;

  useEffect(() => {
    if (dadosOcorrencia) {
      setFieldValue("sqAcaoFiscal", sqAcaoFiscal);
      setFieldValue("sqItemOcorrencia", sqItemOcorrencia);
      setFieldValue("sqItem", dadosOcorrencia.sqItem);
      setFieldValue("dsItem", dadosOcorrencia.dsItem);
      setFieldValue("txReferencia", dadosOcorrencia.txReferencia);
      setFieldValue("dtVencimento", dadosOcorrencia.dtVencimento);
      setFieldValue("vlArrolamento", dadosOcorrencia.vlArrolamento);
      setFieldValue("pcAgregadoAuditor", dadosOcorrencia.pcAgregadoAuditor);
      setFieldValue("vlBaseCalculo", dadosOcorrencia.vlBaseCalculo);
      setFieldValue("pcIcmsAuditor", dadosOcorrencia.pcIcmsAuditor);
      setFieldValue("vlIcms", dadosOcorrencia.vlIcms);
      setFieldValue("tipoDetalhamento", dadosOcorrencia.tipoDetalhamento);
    }

    if (composicao === "SNNN") {
      setFieldValue("vlIcms", 0);
      // setDisabled(true);
    }

    if (composicao === "NNSN") {
      setDisabled(true);
    }

    if (sqAcaoFiscal !== null) {
      buscaComposicao();
    }
  }, [setFieldValue, dadosOcorrencia, sqAcaoFiscal, sqItemOcorrencia, buscaComposicao, composicao]);

  return (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={12}>
          <span>Descrição:</span>
          <HtmlEditor formik={formik} field="dsItem" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Referência:</Form.Label>
          <TextInputMaskFormik
            formik={formik}
            field="txReferencia"
            placeholder="mm/aaaa"
            mask="99/9999"
            evento={calculaData}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Data de Vencimento:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Valor Operação (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlArrolamento"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
        {composicao === "NNSN" && (
          <Form.Group className="mb-3" as={Col} sm={12} md={4}>
            <Form.Label>Agregado (%):</Form.Label>
            <TextInputMoneyFormik
              formik={formik}
              field="pcAgregadoAuditor"
              type="number"
              prefix=" "
              onChange={handleMoneyChange}
              evento={calculaBaseCalculoR}
            />
          </Form.Group>
        )}
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Valor Base de Calculo (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlBaseCalculo"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            disable={disabled}
          />
        </Form.Group>
      </Row>
      <Row>
        {!(composicao === "SNNN") && (
          <Form.Group className="mb-3" as={Col} sm={12} md={4}>
            <Form.Label>Alíquota (%):</Form.Label>
            <TextInputMoneyFormik
              formik={formik}
              field="pcIcmsAuditor"
              type="number"
              prefix=" "
              onChange={handleMoneyChange}
              evento={calculaIcmsR}
            />
          </Form.Group>
        )}

        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>
            <strong>ICMS a Recolher (R$):</strong>
          </Form.Label>{" "}
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcms"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            disable
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default DemonstrativoR;
